import { h, Component } from 'preact';
import s from './matterhorn.sss';

export default class Matterhorn extends Component {

	componentDidMount() {
		if (typeof this.props.onPlayerReady === 'function') {
			this.props.onPlayerReady();
		}
	}

	render(props) {
		const { activeVideo } = props;
		const src = activeVideo.disneySrc;

		return (
			<iframe
				id="matterhorn_player"
				class={s.iframe}
				src={src}
				allowfullscreen
				webkitallowfullscreen
				mozAllowFullScreen
				allow="autoplay *; fullscreen *; encrypted-media *"
				sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
				frameborder="0"
				title="Matterhorn Player"
			/>
		);
	}
}
